import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const updateSoilGroups = async (groupId, data) => {
  return await axios.put(`soil-groups/${groupId}`, data)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default updateSoilGroups;